import networkTS from '@/misc/apis/networkTS'
import {
  InvestPlanCreateBulkEntry,
  InvestPlanCreateBulkPlanEntry,
  InvestPlanEnableEntry,
  InvestPlanUpdateBulkPlanEntry,
  ObjectinvestPlanUpdateBulkEntry
} from '@/types/api'

function normalizeLifeSpan(value: unknown): number {
  if (value === '' || value === null || value === undefined) {
    return 0
  }
  const parsedValue = Number(value)
  if (Number.isNaN(parsedValue)) {
    return 0
  }
  return Math.trunc(parsedValue)
}

function normalizeComponentLifeSpan<T extends InvestPlanCreateBulkEntry | ObjectinvestPlanUpdateBulkEntry>(entry: T): T {
  return {
    ...entry,
    lifeSpan: normalizeLifeSpan(entry.lifeSpan)
  }
}

export default {
  async hasInvestPlanEnabled(buildingIds: string[]) {
    return networkTS.investPlanServiceHasEnabled({ buildingIds: buildingIds })
      .then((response) => {
        return response.data
      })
  },
  async enableInvestPlan(entries: InvestPlanEnableEntry[]) {
    return networkTS.investPlanServiceEnable({ entries: entries })
      .then((response) => {
        return response.data
      })
  },
  async createComponentBulk(entries: InvestPlanCreateBulkEntry[], plans: InvestPlanCreateBulkPlanEntry[] = []) {
    return networkTS.investPlanServiceCreateBulk({ entries: entries.map(normalizeComponentLifeSpan), plans: plans })
      .then(response => {
        return response.data
      })
  },
  async deleteComponent(id: string) {
    return networkTS.investPlanServiceDelete(id)
      .then(response => {
        return response.data
      })
  },
  async listComponentsByReferenceIds(ids: string[]) {
    return networkTS.investPlanServiceListByReferenceIds({ ids: ids })
      .then(response => {
        return response.data
      })
  },
  async updateComponentBulk(entries: ObjectinvestPlanUpdateBulkEntry[], plans: InvestPlanUpdateBulkPlanEntry[] = []) {
    return networkTS.investPlanServiceUpdateBulk({ entries: entries.map(normalizeComponentLifeSpan), plans: plans })
      .then(response => {
        return response.data
      })
  }
}
